import { Series } from "@gtpl/shared-models/common-models";

export class ChartInfo{
        data:Series[];
        xaxis:any[]
}